import { render, staticRenderFns } from "./buy_success2.vue?vue&type=template&id=2115e33c&scoped=true&"
import script from "./buy_success2.vue?vue&type=script&lang=js&"
export * from "./buy_success2.vue?vue&type=script&lang=js&"
import style0 from "./buy_success2.vue?vue&type=style&index=0&id=2115e33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115e33c",
  null
  
)

export default component.exports